import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';
import type { Price } from 'types/capi/shared';

import { sizeSixVariants } from '../domain/sizes';

function hasSize(selectedSize: string, sizes: string[]) {
  if (selectedSize === '6')
    return sizeSixVariants.some((size) => sizes.includes(size));

  return sizes.includes(selectedSize);
}

export function getStockStatusForSize(
  listing?: AffiliateStockListing,
  size?: string
) {
  if (!listing) return 'SOLD_OUT';

  if (
    listing.stock_status === 'IN_STOCK' &&
    size &&
    !hasSize(size, listing.sizes)
  )
    return 'SOLD_OUT';

  return listing.stock_status;
}

export function getSortedStockListingsForSize(
  product: CapiProductPage,
  size?: string
): AffiliateStockListing[] {
  if (!size) return product.stock_listings.affiliates;

  return product.stock_listings.affiliates.slice().sort((a, b) => {
    const aVal = getStockStatusForSize(a, size) === 'IN_STOCK' ? 1 : 0;
    const bVal = getStockStatusForSize(b, size) === 'IN_STOCK' ? 1 : 0;

    return bVal - aVal;
  });
}

export function getPriceForSize(
  listing: AffiliateStockListing,
  size?: string
): Price | undefined {
  const price = listing.size_data.find((d) => d.size === size)?.price;

  if (!price) return;

  return {
    currency: listing.price.currency,
    regular: price,
    sale: listing.price.sale
  };
}

export function getCheapestListing(listing: AffiliateStockListing) {
  const cheapestListing = listing.size_data
    .filter(({ price }) => price)
    .sort((a, b) => {
      return a.price - b.price;
    })[0];

  if (!cheapestListing) return;

  return getPriceForSize(listing, cheapestListing.size);
}
